<script lang="ts" setup>
import { NotificationsState } from '@/store/notifications';
import { Notification } from '@/types/notification';
const props = defineProps<{ notification?: KeyNotification }>();
</script>
<template>
  <div class="w-full">
    <div class="flex justify-between items-center flex-1">
      <p class="text-gray-300">Next key</p>
      <p class="text-white">
        {{ notification.data.newBalanceValue % 1 }} / 1 Key
      </p>
    </div>
    <div class="w-full h-[4px] relative my-2">
      <div
        class="bg-green-5 00 h-full absolute z-10"
        :style="{
          width: (notification.data.newBalanceValue % 1) * 100 + '%',
        }"
      ></div>
      <div class="w-full h-full bg-gray-600"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
